import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { scrollToElement } from '../../utils/helpers';
import { localizePath, splitLanguageFromPath } from '../../utils/language';
import './StickyMobileCTA.css';

const StickyMobileCTA = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Show after scrolling past hero section
            setIsVisible(window.scrollY > 500);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleClick = () => {
        if (splitLanguageFromPath(location.pathname).path === '/') {
            scrollToElement('contact-form');
        } else {
            navigate({ pathname: localizePath(i18n.language, '/'), hash: '#contact-form' });
        }
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    className="sticky-cta"
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <button className="sticky-cta-btn" onClick={handleClick}>
                        <span className="cta-icon" aria-hidden="true">
                            <FontAwesomeIcon icon={faPhone} />
                        </span>
                        <span className="cta-text">{t('cta_sticky.text')}</span>
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default StickyMobileCTA;
